// removed by extract-text-webpack-plugin
module.exports = {"morris-hover":"morris-hover","morris-default-style":"morris-default-style","morris-hover-row-label":"morris-hover-row-label","morris-hover-point":"morris-hover-point"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/morris.js/morris.css
// module id = ./node_modules/morris.js/morris.css
// module chunks = 0